/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBillingPortalSession200Response
 */
export interface CreateBillingPortalSession200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateBillingPortalSession200Response
     */
    url?: string;
}

/**
 * Check if a given object implements the CreateBillingPortalSession200Response interface.
 */
export function instanceOfCreateBillingPortalSession200Response(value: object): value is CreateBillingPortalSession200Response {
    return true;
}

export function CreateBillingPortalSession200ResponseFromJSON(json: any): CreateBillingPortalSession200Response {
    return CreateBillingPortalSession200ResponseFromJSONTyped(json, false);
}

export function CreateBillingPortalSession200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBillingPortalSession200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function CreateBillingPortalSession200ResponseToJSON(json: any): CreateBillingPortalSession200Response {
    return CreateBillingPortalSession200ResponseToJSONTyped(json, false);
}

export function CreateBillingPortalSession200ResponseToJSONTyped(value?: CreateBillingPortalSession200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

